import React from "react";
import { Dropdown, Menu } from "antd";
import { Info } from "assets/icons";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

export type IDataInformation = {
  id: number;
  title: string;
  description: string;
};

type IInformation = {
  informations: IDataInformation[];
};

export const VehicleArrivingInformations = (): IDataInformation[] => {
  const VEHICLES_ARRIVING = useTranslation({ id: "vehicles_arriving" });
  const VEHICLES_ARRIVING_DESCRIPTION = useTranslation({ id: "vehicles_arriving_description" });

  return [
    {
      id: 1,
      title: VEHICLES_ARRIVING,
      description: VEHICLES_ARRIVING_DESCRIPTION,
    },
  ];
};

export const InRadiusInformations = (): IDataInformation[] => {
  const VEHICLES_IN_THE_RADIUS = useTranslation({ id: "vehicles_in_the_radius" });
  const VEHICLES_IN_THE_RADIUS_DESCRIPTION = useTranslation({ id: "vehicles_in_the_radius_description" });

  return [
    {
      id: 1,
      title: VEHICLES_IN_THE_RADIUS,
      description: VEHICLES_IN_THE_RADIUS_DESCRIPTION,
    },
  ];
};

export const NoCheckinInRadiusInformations = (): IDataInformation[] => {
  const NO_CHECK_IN_RADIUS = useTranslation({ id: "no_check_in_radius" });
  const NO_CHECKIN_IN_RADIUS_DESCRIPTION = useTranslation({ id: "no_check_in_radius_description" });

  return [
    {
      id: 1,
      title: NO_CHECK_IN_RADIUS,
      description: NO_CHECKIN_IN_RADIUS_DESCRIPTION,
    },
  ];
};

export const InternQueueInformations = (): IDataInformation[] => {
  const INTERN_QUEUE = useTranslation({ id: "intern_queue" });
  const WAITING_OPERATION_DESCRIPTION = useTranslation({ id: "waiting_operation_description_info" });

  return [
    {
      id: 1,
      title: INTERN_QUEUE,
      description: WAITING_OPERATION_DESCRIPTION,
    },
  ];
};

export const InOperationInformations = (): IDataInformation[] => {
  const IN_OPERATION = useTranslation({ id: "in_operation" });
  const IN_OPERATION_DESCRIPTION = useTranslation({ id: "in_operation_description_info" });

  return [
    {
      id: 1,
      title: IN_OPERATION,
      description: IN_OPERATION_DESCRIPTION,
    },
  ];
};

export const ReleasedNotReleasedInformations = (): IDataInformation[] => {
  const RELEASED_VEHICLE = useTranslation({ id: "released" });
  const VEHICLE_NOT_RELEASED = useTranslation({ id: "not_released" });
  const RELEASED_NOT_RELEASED_DESCRIPTION = useTranslation({ id: "released_or_not_released_description" });

  return [
    {
      id: 1,
      title: `${RELEASED_VEHICLE} / ${VEHICLE_NOT_RELEASED}`,
      description: RELEASED_NOT_RELEASED_DESCRIPTION,
    },
  ];
};

const Informations = ({ informations }: IInformation): JSX.Element => {
  const data = () => (
    <Menu>
      <S.CardInformation>
        {informations.map((item) => (
          <div key={item.id}>
            <S.Title>{item.title}</S.Title>
            <S.Description>{item.description}</S.Description>
          </div>
        ))}
      </S.CardInformation>
    </Menu>
  );
  return (
    <div style={{ height: "24px", width: "24px" }}>
      <Dropdown overlay={data} placement="topRight">
        <Info className="dataInformation" data-testid="dataInformation" height={24} width={24} />
      </Dropdown>
    </div>
  );
};

export default Informations;
